var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "s12 insety-16 border-bottom" }, [
    _c(
      "div",
      {
        staticClass: "after-16 before-8",
        class: { "flex-flex": _vm.$media.l },
      },
      [
        _c("div", { staticClass: "text-semibold mf-label" }, [
          _vm._v(_vm._s(_vm.$t("fund_family"))),
        ]),
        _c(
          "div",
          { class: _vm.$media.l ? "start-32" : "before-16" },
          [
            _c("SelectDrop", {
              ref: "selectDrop",
              staticClass: "fund-fields",
              class: { "after-16": !_vm.isZenith, _err: _vm.hasError },
              attrs: {
                options: _vm.fundFamilies,
                defaultValue: _vm.defaultFundFamily,
                filterFor: "family",
              },
              on: { getSelect: _vm.showFundFamily },
            }),
            _vm.hasError
              ? _c("div", [
                  _c("span", { staticClass: "end-4 _err-icon" }, [
                    _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                      _c("path", {
                        attrs: {
                          d: "M49.78 45.35L25.87 3.93c-.36-.62-1.38-.62-1.74 0L.13 45.5c-.17.3-.17.7 0 1 .18.3.51.5.87.5h48.02a1 1 0 0 0 .76-1.65zM23.49 19.27c0-.22.15-.36.36-.36h2.3c.21 0 .35.14.35.36v14.46c0 .21-.14.36-.35.36h-2.3c-.21 0-.36-.15-.36-.36zm3.09 20.67c0 .21-.15.35-.36.35h-2.44c-.21 0-.35-.14-.35-.35v-2.62c0-.22.14-.36.35-.36h2.44c.22 0 .36.14.36.36z",
                        },
                      }),
                    ]),
                  ]),
                  _c("span", { staticClass: "_err-message" }, [
                    _vm._v(_vm._s(_vm.$t("please_select_fund_family"))),
                  ]),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }